// extracted by mini-css-extract-plugin
export default {"link":"styles_link__PLs0s","modifiedOnTitle":"styles_modifiedOnTitle__6mquG"};